import { gql } from "@apollo/client";

export const STREAM_SETTINGS_MUTATION = gql`
    mutation StreamSettingsMutation(
        $doubleSentry: Boolean!
        $goldenWoh: Boolean!
        $acceptingApplications: Boolean
        $doubleShieldMateRewards: Boolean
        $streamTeamRewardName: String
        $streamTeamRewardDescription: String
        $streamTeamRewardCost: Int
        $streamTeamRewardBackgroundColor: String
        $streamTeamRewardUserInputRequired: Boolean
        $streamTeamRewardSkipQueue: Boolean
        $streamTeamRewardGlobalCooldownEnabled: Boolean
        $streamTeamRewardMaxPerStreamEnabled: Boolean
        $streamTeamRewardMaxPerUserPerStreamEnabled: Boolean
        $streamTeamRewardGlobalCooldownSeconds: Int
        $streamTeamRewardLimitPerStream: Int
        $streamTeamRewardLimitPerUserPerStream: Int
        $streamTeamRewardRpAmount: Int
        $academyRewardName: String
        $academyRewardDescription: String
        $academyRewardCost: Int
        $academyRewardBackgroundColor: String
        $academyRewardUserInputRequired: Boolean
        $academyRewardSkipQueue: Boolean
        $academyRewardGlobalCooldownEnabled: Boolean
        $academyRewardMaxPerStreamEnabled: Boolean
        $academyRewardMaxPerUserPerStreamEnabled: Boolean
        $academyRewardGlobalCooldownSeconds: Int
        $academyRewardLimitPerStream: Int
        $academyRewardLimitPerUserPerStream: Int
        $academyRewardRpAmount: Int
        $raidRpPerViewer: Int
        $raidRpMinimumViewers: Int
        $academyRaidRpEnabled: Boolean
        $subscriberRpAmountTier1000: Int
        $subscriberRpAmountTier2000: Int
        $subscriberRpAmountTier3000: Int
        $academySubscriberRpEnabled: Boolean
        $freeRunestoneRpThreshold: Int
    ) {
        updateStreamSettings(
            doubleSentry: $doubleSentry
            goldenWoh: $goldenWoh
            acceptingApplications: $acceptingApplications
            doubleShieldMateRewards: $doubleShieldMateRewards
            streamTeamRewardName: $streamTeamRewardName
            streamTeamRewardDescription: $streamTeamRewardDescription
            streamTeamRewardCost: $streamTeamRewardCost
            streamTeamRewardBackgroundColor: $streamTeamRewardBackgroundColor
            streamTeamRewardUserInputRequired: $streamTeamRewardUserInputRequired
            streamTeamRewardSkipQueue: $streamTeamRewardSkipQueue
            streamTeamRewardGlobalCooldownEnabled: $streamTeamRewardGlobalCooldownEnabled
            streamTeamRewardMaxPerStreamEnabled: $streamTeamRewardMaxPerStreamEnabled
            streamTeamRewardMaxPerUserPerStreamEnabled: $streamTeamRewardMaxPerUserPerStreamEnabled
            streamTeamRewardGlobalCooldownSeconds: $streamTeamRewardGlobalCooldownSeconds
            streamTeamRewardLimitPerStream: $streamTeamRewardLimitPerStream
            streamTeamRewardLimitPerUserPerStream: $streamTeamRewardLimitPerUserPerStream
            streamTeamRewardRpAmount: $streamTeamRewardRpAmount
            academyRewardName: $academyRewardName
            academyRewardDescription: $academyRewardDescription
            academyRewardCost: $academyRewardCost
            academyRewardBackgroundColor: $academyRewardBackgroundColor
            academyRewardUserInputRequired: $academyRewardUserInputRequired
            academyRewardSkipQueue: $academyRewardSkipQueue
            academyRewardGlobalCooldownEnabled: $academyRewardGlobalCooldownEnabled
            academyRewardMaxPerStreamEnabled: $academyRewardMaxPerStreamEnabled
            academyRewardMaxPerUserPerStreamEnabled: $academyRewardMaxPerUserPerStreamEnabled
            academyRewardGlobalCooldownSeconds: $academyRewardGlobalCooldownSeconds
            academyRewardLimitPerStream: $academyRewardLimitPerStream
            academyRewardLimitPerUserPerStream: $academyRewardLimitPerUserPerStream
            academyRewardRpAmount: $academyRewardRpAmount
            raidRpPerViewer: $raidRpPerViewer
            raidRpMinimumViewers: $raidRpMinimumViewers
            academyRaidRpEnabled: $academyRaidRpEnabled
            subscriberRpAmountTier1000: $subscriberRpAmountTier1000
            subscriberRpAmountTier2000: $subscriberRpAmountTier2000
            subscriberRpAmountTier3000: $subscriberRpAmountTier3000
            academySubscriberRpEnabled: $academySubscriberRpEnabled
            freeRunestoneRpThreshold: $freeRunestoneRpThreshold
        ) {
            success
        }
    }
`;

export const SYNC_MY_STREAM_TEAM_CHANNEL_POINT_REWARD_MUTATION = gql`
    mutation SyncMyStreamTeamChannelPointReward {
        syncMyStreamTeamChannelPointReward {
            success
            rewardId
        }
    }
`;

export const REMOVE_MY_STREAM_TEAM_CHANNEL_POINT_REWARD_MUTATION = gql`
    mutation RemoveMyStreamTeamChannelPointReward {
        removeMyStreamTeamChannelPointReward {
            success
        }
    }
`;

export const SYNC_STREAM_TEAM_CHANNEL_POINT_REWARDS_FROM_SETTINGS_MUTATION = gql`
    mutation SyncStreamTeamChannelPointRewardsFromSettings($memberId: UUID) {
        syncStreamTeamChannelPointRewardsFromSettings(memberId: $memberId) {
            success
            updatedCount
            failedCount
        }
    }
`;
